import { Injectable } from "@angular/core";
import { SampleApiUrlUtil } from "@sharedcommon/util/sample-service.util";
import { Observable } from "rxjs";
import { NeqHttpClient } from "@sharedcommon/rest/http-client.config";
import { ComputeDto } from "@sharedcommon/rest/data.restservice";

@Injectable({ providedIn: 'root'})
export class SampleTempCalculationRestService {
  constructor(private neqHttpClient: NeqHttpClient){}

  /**
   * Definitly Save the temporary calculation
   * Response code 204 - save success
   * Response code 500 - Error
   * HTTP POST temp-calculation/{id}/save
   * Java method: 
   */
  saveSave(tempCalculationId: string): Observable<void> {
    return this.neqHttpClient.request({ method: 'POST', url: SampleApiUrlUtil.formatApiUrl(`temp-calculation/${tempCalculationId}/save`) });
  }


  /**
   * Force the calculation status
   * Response code 200 - force the calculation status of a temp calculation
   * Response code 500 - Error
   * HTTP PATCH temp-calculation/{id}/force-calc-status
   * Java method: 
   */
  forceCalcStatus(tempCalculationId: string): Observable<ComputeDto> {
    return this.neqHttpClient.request({ method: 'PATCH', url: SampleApiUrlUtil.formatApiUrl(`temp-calculation/${tempCalculationId}/force-calc-status`) });
  }
}